/* eslint-disable max-len */
import React from 'react';

const PromosIcon: React.FC<object> = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_11604_124078)">
                <g clipPath="url(#clip1_11604_124078)">
                    <path
                        d="M6.62207 0.84082C7.45739 0.289467 8.54162 0.289496 9.37695 0.84082L9.85938 1.15918C10.3819 1.50404 10.9871 1.70309 11.6123 1.73438L11.8926 1.74805C13.1883 1.81281 14.2196 2.85788 14.2666 4.1543L14.2754 4.40918C14.2986 5.0512 14.4986 5.67476 14.8525 6.21094L15.1582 6.6748C15.7094 7.51008 15.7094 8.59344 15.1582 9.42871L14.8525 9.89258C14.4986 10.4288 14.2986 11.0523 14.2754 11.6943L14.2686 11.874C14.2206 13.197 13.1497 14.2536 11.8262 14.2832L11.6719 14.2861C11.0133 14.3009 10.3721 14.5014 9.82227 14.8643L9.37695 15.1582C8.54161 15.7096 7.45741 15.7096 6.62207 15.1582L6.17773 14.8643C5.628 14.5014 4.98665 14.301 4.32812 14.2861L4.17285 14.2832C2.84935 14.2536 1.7784 13.197 1.73047 11.874L1.72363 11.6943C1.7004 11.0523 1.50137 10.4288 1.14746 9.89258L0.84082 9.42871C0.289712 8.59351 0.289712 7.51001 0.84082 6.6748L1.14746 6.21094C1.50137 5.67476 1.70039 5.0512 1.72363 4.40918L1.7334 4.1543C1.78044 2.85797 2.81089 1.81292 4.10645 1.74805L4.38672 1.73438C5.01204 1.70312 5.61809 1.50408 6.14062 1.15918L6.62207 0.84082Z"
                        stroke="currentColor"
                    />
                    <path
                        d="M11.5607 9.43945C12.1465 10.0251 12.1465 10.975 11.5607 11.5607C10.975 12.1467 10.0253 12.1467 9.43933 11.5607C8.85361 10.975 8.85361 10.0251 9.43933 9.43945C10.0251 8.85376 10.975 8.85376 11.5607 9.43945Z"
                        fill="currentColor"
                    />
                    <path
                        d="M6.56074 4.43945C7.14647 5.02514 7.14647 5.97505 6.56074 6.56074C5.97502 7.14667 5.02529 7.14667 4.43933 6.56074C3.85361 5.97505 3.85361 5.02514 4.43933 4.43945C5.02506 3.85376 5.97502 3.85376 6.56074 4.43945Z"
                        fill="currentColor"
                    />
                    <path
                        d="M5 11L11 5"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_11604_124078">
                    <rect
                        width="16"
                        height="16"
                        fill="currentColor"
                    />
                </clipPath>
                <clipPath id="clip1_11604_124078">
                    <rect
                        width="16"
                        height="16"
                        fill="currentColor"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default PromosIcon;